import React from "react";
import CircularLoader from "../../../../../components/common/CircularLoader/CircularLoader";
import {
  NumberWithInternationalSign,
  formatDateIntoDMYToDisplay,
} from "../../../../../Utils/utils";

const FundingOverViewTable = (props) => {
  const { Heading, fundingList } = props;

  return (
    <div className="mt-4 relative overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
      <div className=" bg-gray-100 font-medium h-20 py-4 pl-4 border col-span-2 flex justify-between">
        <div className="text-[#101828] font-semibold text-lg pt-2">
          {Heading}
        </div>
      </div>
      <table className="min-w-full table-fixed divide-y divide-gray-300 bg-white">
        <thead className="capitalize">
          <tr className="bg-[#F5FAFF]">
            <th
              scope="col"
              className="min-w-[4rem] pl-5 px-3 py-3.5 text-left text-xs font-semibold text-[#101828]"
            >
              ID
            </th>

            <th
              scope="col"
              className="px-3 py-3.5 text-left text-xs font-semibold text-[#101828]"
            >
              End date
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-xs font-semibold text-[#101828]"
            >
              Total
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-xs font-semibold text-[#101828]"
            >
              Remaining
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 bg-white">
          {!fundingList ? (
            <tr>
              <td colSpan={4} className="py-6 text-center text-red-600">
                <CircularLoader
                  classes="flex justify-center items-center"
                  classloader="loader-l"
                />
              </td>
            </tr>
          ) : fundingList && fundingList.length > 0 ? (
            fundingList.map((funding, index) => (
              <tr
                key={index}
                className={`even:bg-white odd:bg-gray-50 ${
                  funding.is_expired ? "bg-red-50/80" : ""
                }`}
              >
                <td
                  className={`whitespace-nowrap px-3 py-4 text-sm font-medium ${
                    funding.is_expired ? "text-red-600" : "text-[#101828]"
                  }`}
                >
                  {funding.contract_id}
                  {funding.is_expired ? (
                    <span className="ml-1 text-xs font-normal">(Expired)</span>
                  ) : null}
                </td>
                <td
                  className={`whitespace-nowrap px-3 py-4 text-sm font-medium ${
                    funding.is_expired ? "text-red-600" : "text-[#101828]"
                  }`}
                >
                  {funding.end_date
                    ? formatDateIntoDMYToDisplay(funding.end_date)
                    : "—"}
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm font-medium text-[#101828]">
                  {`$${NumberWithInternationalSign(
                    funding.total_contract_amount.replace("$", ""),
                    true,
                    2
                  )}`}
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm font-medium text-[#101828]">
                  {`$${NumberWithInternationalSign(
                    funding.amount_remaining.replace("$", ""),
                    true,
                    2
                  )}`}
                </td>
              </tr>
            ))
          ) : (
            !fundingList ||
            (fundingList.length === 0 && (
              <tr>
                <td colSpan={4} className="py-6 text-center text-red-600">
                  No data found !
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};
export default FundingOverViewTable;
